import { baseUrl } from "./Constants";
import { processAndUpdateToken } from "./CommonFunctions";
import axios from "axios";
import jwtDecode from "jwt-decode";

// -------------------- LOAD CLIENTS --------------------
export const loadClientsService = async () => {
  let url = new URL(window.location.href);
  let urlParamToken = url?.searchParams.get("token");

  const decode_UserName = jwtDecode(urlParamToken || "");
  const csrQuoteAuthUserName = decode_UserName?.preferred_username;

  let token = sessionStorage.getItem("token");
  token = await processAndUpdateToken(token);

  const clientToGetBroker = {
    Email: csrQuoteAuthUserName,
  };

  const res = await axios.post(
    `${baseUrl}/api/ProposalBuilder/GetClient/GetClientsForBroker`,
    clientToGetBroker,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return {
    data: res?.data,
    brokerId: res?.data?.brokerId,
    clientEmail: csrQuoteAuthUserName,
  };
};

// -------------------- FETCH JOB DATA --------------------
export const fetchJobsService = async (clientName) => {
  const token = await processAndUpdateToken(sessionStorage.getItem("token"));
  const Broker = sessionStorage.getItem("proposalBrokerId");

  const url = `${baseUrl}/api/ProposalBuilder/GetClientJobs/${Broker}/GetJobs?clientName=${encodeURIComponent(
    clientName,
  )}`;

  const res = await axios.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return res.data;
};

// -------------------- SAVE PROPOSAL --------------------
export const saveProposalService = async (sectionState, sectionStatus, lobSplitJobIds = []) => {
    const targetLobs = [
        "commercial package",
        "homeowners",
        "business owners policy",
        "package",
    ];

    const token = await processAndUpdateToken(sessionStorage.getItem("token"));

    const firstRow = Object.values(sectionState)[0];
    const filteredSectionStatus = sectionStatus?.filter((row) => {
        if (lobSplitJobIds.includes(row?.JobId)) {
        return !targetLobs.includes(row?.Lob?.toLowerCase());
        }

        return true;
    });

    const jobIds = [...new Map(
        filteredSectionStatus?.map(row => [row.JobId, row.JobId])
        ).values()];

    const lobs = filteredSectionStatus?.map(row => row?.Lob);

    const payload = {
        Data: [
            {
                BrokerId: firstRow?.BrokerId,
                JobIds: jobIds,
                Lobs: lobs,
                ClientName: firstRow?.ClientName,
                CoverPage: firstRow?.CoverPage,
                TableOfContent: firstRow?.TableOfContent,
                CommonInformation: firstRow?.CommonInformation,
                NameInsuredOrSchedule: firstRow?.NameInsuredOrSchedule,
                PremiumSummary: firstRow?.PremiumSummary,
                CoverageSummary: firstRow?.CoverageSummary,
                Schedule: firstRow?.Schedule == null ? false : firstRow?.Schedule,
            },
        ],
    };

    const res = await axios.post(
        `${baseUrl}/api/ProposalBuilder/SaveProposalSectionStatus/SaveProposal`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

  return res.data;
};

// -------------------- BUILD PROPOSAL --------------------
export const buildProposalService = async (payload) => {
  const token = await processAndUpdateToken(sessionStorage.getItem("token"));

    const res = await axios.post(
        `${baseUrl}/api/ProposalBuilder/CreateTemplate/BuildTemplate`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            responseType: "blob",
        }
    );

  return res;
};
